import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
} from "App/constants";
import {
  InputOptionMaster,
  InputCheckboxMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";

import { useInitialLayanan } from "App/hooks";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_LAYANAN = {
  id: "",
  name: "",
  layanan_id: "",
  layanan: "",
  initial: "",
  status: true,
  remark: "",
};
export const getAllLayananRuang = async () => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.ruang_layanan.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteLayananRuangById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.ruang_layanan.delete,
      {},
      {
        headers: {
          idlayanan_ruang: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_LAYANAN);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "layanan_id",
    disablePadding: false,
    label: "LAYANAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "initial",
    disablePadding: false,
    label: "INITIAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, formData, setFormData, run }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const layanan = useInitialLayanan(
    true,
    true,
    LIST_URL_MASTER.ruang_layanan.layanan
  );
  const addLayananRuang = async () => {
    return instance1.post(LIST_URL_MASTER.ruang_layanan.add, {
      ...formData,
    });
  };

  const updateLayananRuang = () => {
    return instance1.post(
      LIST_URL_MASTER.ruang_layanan.update,
      {
        ...formData,
      },
      {
        headers: {
          idlayanan_ruang: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.layanan_id === "" || formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Layanan dan Nama tidak boleh kosong");
    }

    try {
      if (formData.id === "") {
        await addLayananRuang();
      } else if (formData.id !== "") {
        await updateLayananRuang();
      }
      run(!run);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      setShowModal(false);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Layanan Ruang`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputOptionMaster
              name='layanan_id'
              label='Layanan'
              id='layanan_id'
              withSearch={true}
              value={formData.layanan_id}
              labelValue={formData.layanan}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  layanan_id: e.value,
                  layanan: e.label,
                });
              }}
              data={layanan}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='initial'
              label='Initial'
              id='initial'
              value={formData.initial}
              onChange={handleChange("initial")}
              placeholder='Initial'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>

          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
